// external
import { region } from '../localizations/current-locale';
import { dynamicBrand } from '../utils/brand';

// internal
import { valid, invalid } from '../utils/validators/resolutions';

let messages;
import(`../utils/text-resources/${dynamicBrand()}/${region}/messages`).then((m) => {
  messages = m.default;
});

const validatePurpose = (input = '') => {
  if (!/\S+/.test(input || '')) {
    return invalid(messages.purposeIsRequired);
  }

  return valid();
};

export default validatePurpose;
